import requestApi from "@/utils/requestApi";
import _ from "lodash";

function setGlobalStateDefault() {
  var currentVersion = 9;
  var previousVideobotState = window.ovmConfig.env["@VIDEOBOT_STATE"];
  var globalState = null;

  if (
    previousVideobotState &&
    previousVideobotState.version === currentVersion
  ) {
    globalState = JSON.parse(JSON.stringify(previousVideobotState));
  }

  if (!globalState) {
    globalState = _.merge(INITIAL_GLOBAL_STATE, previousVideobotState);
  }

  this.globalState = globalState;
}

function setUUID() {
  var uuid = getUrlParameter("id");
  if (process.env.NODE_ENV === "development") {
    uuid = "9ebad3c9-2503-42f4-889c-5c3361aeb57c";
    // producao 9ebad3c9-2503-42f4-889c-5c3361aeb57c
    // staging 6ed3fbc5-2ee8-4290-9918-3305aaadb87b
  } else {
    uuid = getUrlParameter("id");
  }
  this.uuid = uuid;
}

async function load() {
  if (process.env.NODE_ENV === "development") {
    console.log("REQUEST SAVE_STATE DEV");
    return;
  }
  var videobot_state = {
    videobot_state: this.globalState,
  };
  var uuid = this.uuid;
  try {
    const response = await requestApi({
      url: `/brand_channel_sessions/${uuid}/save_state`,
      method: "post",
      data: videobot_state,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
  }
}

const INITIAL_GLOBAL_STATE = {
  percentage: {
    beneficios: 0,
    acolhimento: 0,
    conteudos_maternidade: 0,
    conteudos_parentalidade: 0,
    cuidados_com_o_bebe: 0,
    e_books: 0,
    licenca_maternidade: 0,
    licenca_parental_paternidade: 0,
    links_uteis: 0,
    programas_bem_estar: 0,
    reonboarding: 0,
  },
  interactives: {
    content: {
      view: {
        beneficios: [""],
        acolhimento: [""],
        conteudos_maternidade: [""],
        conteudos_parentalidade: [""],
        cuidados_com_o_bebe: [""],
        e_books: [""],
        licenca_maternidade: [""],
        licenca_parental_paternidade: [""],
        links_uteis: [""],
        programas_bem_estar: [""],
        reonboarding: [""],
        first_play: true,
      },
    },
  },
  selectedData: {
    profile: null,
    firstViewedDate: null,
    returnDate: null,
    viewedAvaliacaoPeriodica: 0,
    doneAvaliacao: false,
    acceptedEntrelacos: null,
  },
  status: {
    formsCompleted: false,
    menu_viewed: false,
  },
  avaliacoes: {
    trilha_de_cuidados: [],
    cuidados_com_novo_familiar: [],
    acolhimento: [],
    reonboarding: [],
  },
  version: 9,
};

function getUrlParameter(name) {
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function calcularQtdConteudo(videobotContent) {
  for (const key in this.cont_conteudo) {
    if (videobotContent[key]) {
      const elementsChildren = videobotContent[key];
      let count = 0;
      for (const keyChildren in elementsChildren) {
        if (elementsChildren[keyChildren]) {
          const element = elementsChildren[keyChildren];
          if (element.subtitle == "MENU" || keyChildren.includes("menu")) {
            let strSemMenu = keyChildren.replace("_menu", "");
            let objectConteudoSubmenu =
              videobotContent["submenu_" + strSemMenu];
            count += Object.keys(objectConteudoSubmenu).length + 1;
          } else {
            count += 1;
          }
        }
      }
      this.cont_conteudo[key] = count;
    }
  }
  this.calcularPorcentagemTotal();
}

function setViewContent(key_menu, key_item) {
  if (
    !this.globalState.interactives.content.view[key_menu].includes(key_item)
  ) {
    this.globalState.interactives.content.view[key_menu].push(key_item);
  }
  this.calculatePercentage();
}

function calculatePercentage() {
  for (const key in this.globalState.percentage) {
    let porcentagem = 0;
    let totalItens = this.cont_conteudo[key];
    let itensVisualizados =
      this.globalState.interactives.content.view[key]?.length - 1;
    if (key === "conteudos_parentalidade") {
      porcentagem = (itensVisualizados / (totalItens - 10)) * 100;
    } else if (key === "reonboarding") {
      porcentagem = (itensVisualizados / (totalItens - 2)) * 100;
    } else if (totalItens != 0) {
      porcentagem = (itensVisualizados / totalItens) * 100;
    } else {
      porcentagem = 100;
    }
    this.globalState.percentage[key] = Math.round(porcentagem);
  }
  this.calcularPorcentagemTotal();
}

function calcularPorcentagemTotal() {
  let sum_porcentagem = 0;
  for (const key in this.globalState.percentage) {
    sum_porcentagem += this.globalState.percentage[key];
  }
  this.porcentagemTotal = Math.round(sum_porcentagem / 11);
}

function calcularPorcentagemFamiliar() {
  //cuidados com seu novo familiar
  let sum_porcentagem = 0;
  let lista = ["cuidados_com_o_bebe"];
  for (const key in this.globalState.percentage) {
    if (lista.includes(key)) {
      sum_porcentagem += this.globalState.percentage[key];
    }
  }
  var total = Math.round(sum_porcentagem);
  this.openAvaliacaoModal(total, "cuidados_com_novo_familiar");

  return total;
}

function calcularPorcentagemAcolhimento() {
  //acolhimento
  let sum_porcentagem = 0;
  let lista = ["acolhimento"];
  for (const key in this.globalState.percentage) {
    if (lista.includes(key)) {
      sum_porcentagem += this.globalState.percentage[key];
    }
  }
  var total = Math.round(sum_porcentagem);
  this.openAvaliacaoModal(total, "acolhimento");

  return total;
}

function calcularPorcentagemReonboarding() {
  // reonboarding
  let sum_porcentagem = 0;
  let lista = ["reonboarding"];
  for (const key in this.globalState.percentage) {
    if (lista.includes(key)) {
      sum_porcentagem += this.globalState.percentage[key];
    }
  }
  var total = Math.round(sum_porcentagem);
  this.openAvaliacaoModal(total, "reonboarding");

  return total;
}

function calcularPorcentagemVoce() {
  // cuidados com voce
  let sum_porcentagem = 0;
  let lista = [
    "beneficios",
    "programas_bem_estar",
    "licenca_maternidade",
    "licenca_parental_paternidade",
    "conteudos_maternidade",
    "conteudos_parentalidade",
    "e_books",
    "links_uteis",
  ];
  for (const key in this.globalState.percentage) {
    if (lista.includes(key)) {
      sum_porcentagem += this.globalState.percentage[key];
    }
  }
  var total = Math.round(sum_porcentagem / 8);
  this.openAvaliacaoModal(total, "trilha_de_cuidados");
  return total;
}

function openAvaliacaoModal(porcentagem, tipoAvaliacao) {
  console.log(
    "openAvaliacaoModal",
    porcentagem,
    tipoAvaliacao,
    this.globalState.avaliacoes,
  );

  if (porcentagem > 20 && porcentagem <= 40)
    this.avaliacaoModal.porcentagem = 30;
  else if (porcentagem > 40 && porcentagem <= 60)
    this.avaliacaoModal.porcentagem = 50;
  else if (porcentagem > 60 && porcentagem <= 80)
    this.avaliacaoModal.porcentagem = 70;
  else if (porcentagem > 80 && porcentagem < 100)
    this.avaliacaoModal.porcentagem = 90;
  else if (porcentagem >= 100) this.avaliacaoModal.porcentagem = 100;
  else return;
  if (
    (this.globalState.avaliacoes &&
      this.globalState.avaliacoes[tipoAvaliacao].includes(
        this.avaliacaoModal.porcentagem,
      )) ||
    this.avaliacaoModal.isOpen
  )
    return;

  this.avaliacaoModal.tipoAvaliacao = tipoAvaliacao;
  this.avaliacaoModal.isOpen = true;
  window.felixBag?.trigger(
    window.Ovm?.JB.Cmd.SHOW_INTERACTIVE,
    "avaliacao-periodica",
  );
}

async function loadNotification() {
  const response = await requestApi({
    url: `/v2/bcs_notifications`,
    method: "get",
    headers: {
      BCS: this.uuid,
      "Content-Type": "application/json",
    },
  });

  return response.notifications;
}

export const actions = {
  load,
  setGlobalStateDefault,
  setUUID,
  calcularQtdConteudo,
  setViewContent,
  calculatePercentage,
  calcularPorcentagemTotal,
  loadNotification,
  calcularPorcentagemFamiliar,
  calcularPorcentagemReonboarding,
  calcularPorcentagemVoce,
  calcularPorcentagemAcolhimento,
  openAvaliacaoModal,
};
